module.exports = __webpack_public_path__ + "img/pkp.0a0dc8b2.jpeg";